import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { environment } from "environments/environment";
import { Router } from "@angular/router";
import { LoginForm } from "app/interfaces/login-form.interface";

import { map } from "rxjs/operators";
import { domain } from "../../../environments/environment";

const loginUrlApi = environment.loginUrlApi;
const logoutUrlApi = environment.logoutUrlApi;
const loginAdminToClientUrlApi = environment.loginAdminToClientUrlApi;
const recoveryPasswordSendMailUrlApi =
  environment.recoveryPasswordSendMailUrlApi;
const recoveryPasswordUrlApi = environment.recoveryPasswordUrlApi;
const userPermissionsUrlApi = environment.userPermissionsUrlApi;
const userViewPermissionsUrlApi = environment.userViewPermissionsUrlApi;

@Injectable()
export class AuthService {
  constructor(private router: Router, private http: HttpClient) {}

  private static normalizeBooleanFlag(
    value: any,
    defaultValue: boolean = true
  ): boolean {
    if (value === null || value === undefined || value === "") {
      return defaultValue;
    }

    if (typeof value === "boolean") {
      return value;
    }

    if (typeof value === "number") {
      return value !== 0;
    }

    if (typeof value === "string") {
      const normalizedValue = value.trim().toLowerCase();

      if (normalizedValue === "false" || normalizedValue === "0") {
        return false;
      }

      if (normalizedValue === "true" || normalizedValue === "1") {
        return true;
      }
    }

    return Boolean(value);
  }

  login(formData: LoginForm) {
    return this.http
      .post(`${loginUrlApi}`, formData, {})
      .pipe(map((resp: any) => resp));
  }

  getUserPermissions() {
    return this.http
      .request("GET", `${userPermissionsUrlApi}`, { responseType: "json" })
      .pipe(map((resp: any) => resp));
  }

  getUserViewPermissions(id: number) {
    return this.http
      .request("GET", `${userViewPermissionsUrlApi}/` + id)
      .pipe(map((resp: any) => resp));
  }

  logout(id: number) {
    const body = { id: id };
    return this.http
      .post(`${logoutUrlApi}`, { body })
      .pipe(map((resp: any) => resp));
  }

  loginAdminToClient(name: string) {
    const body = { username: name };
    return this.http
      .request("POST", `${loginAdminToClientUrlApi}`, { body })
      .pipe(map((resp: any) => resp));
  }

  recoveryPasswordMail(id: number) {
    const body = { id: id, baseURL: domain.baseUrl };
    return this.http
      .request("POST", `${recoveryPasswordSendMailUrlApi}`, { body })
      .pipe(map((resp: any) => resp));
  }

  recoveryPasswordSendNew(password, tokenPassword) {
    const body = { pass: password, passwordToken: tokenPassword };
    return this.http
      .request("PUT", `${recoveryPasswordUrlApi}`, { body })
      .pipe(map((resp: any) => resp));
  }

  saveLocalStorage(objectName: string, val: string) {
    localStorage.setItem(objectName, val);
  }

  saveUseExternalRecorderFromResponse(response: any) {
    const useExternalRecorder =
      response?.data?.USE_EXTERNAL_RECORDERS ??
      response?.data?.use_external_recorders ??
      response?.data?.USE_EXTERNAL_RECORDER ??
      response?.data?.use_external_recorder ??
      response?.USE_EXTERNAL_RECORDERS ??
      response?.use_external_recorders ??
      response?.USE_EXTERNAL_RECORDER ??
      response?.use_external_recorder;

    this.saveLocalStorage(
      environment.storageUseExternalRecorderNameApi,
      AuthService.normalizeBooleanFlag(useExternalRecorder, true)
        ? "true"
        : "false"
    );
  }

  static getFromStorage(objectName: string) {
    return localStorage.getItem(objectName);
  }

  static isExternalRecorderEnabled(): boolean {
    return AuthService.normalizeBooleanFlag(
      localStorage.getItem(environment.storageUseExternalRecorderNameApi),
      true
    );
  }

  getFromStorage(objectName: string) {
    return localStorage.getItem(objectName);
  }

  deleteFromStorage(objectName: string) {
    localStorage.removeItem(objectName);
  }

  deleteAllStorage() {
    localStorage.clear();
  }

  /* register(formData: RegisterForm) {
    return this.http
      .post(`${loginUrlApi}/register`, formData)
      .pipe(map((resp: any) => resp));
  } */
}
